import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {CoachingRoleModel, CoachingSummaryModel} from '../model/coaching-summary.model';
import {CoachingReportModel} from '../model/coaching-report.model';
import {CoachingFormModel, CoachingFormResponseModel} from '../model/coaching-form.model';
import {EventsService} from '../../../services/events.service';


@Injectable({
    providedIn: 'root'
})
export class CoachingService {


    constructor(
        private event: EventsService,
        private requesterService: RequesterService
    ) {
    }

    getMyCoachingSummary(): Promise<CoachingSummaryModel> {
        return this.requesterService.get('getMyCoachingSummary')
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getMyCoachingSummary >> ', e);
            });
    }

    getUserCoachingSummary(id: number): Promise<CoachingSummaryModel> {
        return this.requesterService.get('getUserCoachingSummary', {del_id: id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getUserCoachingSummary >> ', e);
            });
    }

    getCoachingReport(id: number): Promise<CoachingReportModel> {
        return this.requesterService.get('getCoachingReport', {coaching_id: id})
            .then(data => {
                if (!!data.result) {
                    this.event.publish('coaching:getCoachingReport', data.result);
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getCoachingReport >> ', e);
            });
    }

    getCoachingEmptyReport(delegateId: number): Promise<CoachingReportModel> {
        return this.requesterService.get('getCoachingEmptyReport', {del_id: delegateId})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getCoachingEmptyReport >> ', e);
            });
    }

    getCoachingForm(id: number = 0): Promise<CoachingFormModel> {
        return this.requesterService.get('getCoachingForm', {coaching_id: id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getCoachingForm >> ', e);
            });
    }

    getCoachingNewForm(delegateId: number = 0): Promise<CoachingFormModel> {
        return this.requesterService.get('getCoachingNewForm', {delegate_id: delegateId})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getCoachingNewForm >> ', e);
            });
    }

    saveCoachingForm(form: CoachingFormModel): Promise<CoachingFormResponseModel> {
        return this.requesterService.post('saveCoachingForm', form)
            .then(data => {
                const response = new CoachingFormResponseModel();
                if (!!data.result.status) {
                    this.event.publish('coaching:saveCoachingForm', form.id);
                    response.status = data.result;
                } else {
                    response.form = data.result;
                }
                return response;
            }).catch(e => {
                return null;
                console.log('Error getCoachingForm >> ', e);
            });
    }

    getCoachingRolesList(): Promise<CoachingRoleModel[]> {
        return this.requesterService.get('getCoachingRolesList')
            .then(data => {
                if (!!data.result) {
                    return data.result;
                } else {
                    return [];
                }
            }).catch(e => {
                return [];
                console.log('Error getCoachingRolesList >> ', e);
            });
    }

    getTeamCoachingList(managerId: number = 0, roleId: number = 0): Promise<CoachingSummaryModel[]> {
        return this.requesterService.get('getTeamCoachingList', {manager_id: managerId, role_id: roleId})
            .then(data => {
                if (!!data.result.delegates) {
                    return data.result.delegates;
                } else {
                    return [];
                }
            }).catch(e => {
                return null;
                console.log('Error getTeamCoachingList >> ', e);
            });
    }


}
